import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { use, useTranslate, useUIComponents } from "@bluelibs/x-ui";
import * as Ant from "antd";
import moment from "moment";
import { TransactionCreateForm } from "../../config/TransactionCreateForm";
import { useEffect, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { CompaniesCollection, ExternalsCollection, } from "@bundles/UIAppBundle/collections";
import { FileUpload } from "@bundles/UIAppBundle/components/FileUpload/FileUpload";
import { TransactionType, UserRole } from "@root/api.types";
import { useAppGuardian } from "@bundles/UIAppBundle/services/AppGuardian";
import { useLazyQuery } from "@apollo/client";
import { BankAccountsFind } from "@bundles/UIAppBundle/queries/BankAccountsFind";
const formLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};
const formTailLayout = {
    wrapperCol: { offset: 8, span: 16 },
};
export const TransactionsCreateWidget = ({ onSuccess }) => {
    var _a, _b;
    const UIComponents = useUIComponents();
    const t = useTranslate();
    const form = use(TransactionCreateForm, { transient: true });
    const { state } = useAppGuardian();
    const isAdmin = ((_b = (_a = state === null || state === void 0 ? void 0 : state.user) === null || _a === void 0 ? void 0 : _a.roles) !== null && _b !== void 0 ? _b : []).find((role) => [UserRole.ADMIN, UserRole.SHAREHOLDER].includes(role))
        ? true
        : false;
    const [status, setStatus] = useState(false);
    const externalsCollection = use(ExternalsCollection);
    const [externals, setExternals] = useState([]);
    const [externalsLoading, setExternalsLoading] = useState(false);
    const [bankAccounts, setBankAccounts] = useState([]);
    const [queryBankAccounts, { loading: bankAccountsLoading }] = useLazyQuery(BankAccountsFind, { fetchPolicy: "no-cache" });
    const [formRef] = Ant.Form.useForm();
    const companyId = Ant.Form.useWatch("companyId", formRef);
    const [transactionType, setTransactionType] = useState("all");
    const fetchExternals = async () => {
        setExternalsLoading(true);
        let filter = {};
        switch (transactionType) {
            case TransactionType.income:
                filter = { type: "client" };
                break;
            case TransactionType.expense:
                filter = { type: "provider" };
                break;
            default:
                filter = undefined;
                break;
        }
        const externalsData = await externalsCollection.find({
            filters: filter,
        }, { _id: true, name: true, type: true });
        setExternals(externalsData);
        setExternalsLoading(false);
    };
    const fetchBankAccounts = async () => {
        queryBankAccounts({
            variables: {
                query: {
                    filters: {
                        $and: [
                            {
                                companyId: {
                                    $in: [
                                        {
                                            $objectId: companyId,
                                        },
                                    ],
                                },
                            },
                        ],
                    },
                },
            },
        })
            .then((res) => { var _a, _b; return setBankAccounts((_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.BankAccountsFind) !== null && _b !== void 0 ? _b : []); })
            .catch((err) => console.log(err));
    };
    useEffect(() => {
        fetchExternals();
    }, [transactionType]);
    useEffect(() => {
        fetchBankAccounts();
    }, [companyId]);
    return (_jsxs(_Fragment, { children: [_jsx(Ant.Button, Object.assign({ onClick: () => setStatus(true), icon: _jsx(PlusOutlined, { style: { fontSize: 17 } }, void 0), type: "ghost" }, { children: t("management.transactions.create_transaction") }), void 0), _jsx(Ant.Modal, Object.assign({ width: 800, open: status, onCancel: () => setStatus(false), footer: null, style: {
                    top: 0,
                    right: 0,
                    padding: 0,
                    position: "absolute",
                    margin: "0px",
                }, bodyStyle: {
                    height: "100vh",
                    width: "100%",
                    maxWidth: "800px",
                    overflowY: "scroll",
                    overflowX: "hidden",
                } }, { children: _jsxs("div", Object.assign({ className: "page-transactions-create-widget" }, { children: [_jsx(Ant.PageHeader, { title: t("management.transactions.create.header") }, void 0), _jsxs(Ant.Form, Object.assign({}, formLayout, { form: formRef, requiredMark: "optional", onFinish: (document) => {
                                if (!isAdmin) {
                                    delete document.isCompleted;
                                }
                                form.onSubmit({
                                    ...document,
                                }, false, () => {
                                    setStatus(false);
                                    onSuccess && onSuccess();
                                });
                            } }, { children: [_jsx(Ant.Form.Item, Object.assign({ label: t("management.transactions.fields.transactionType") }, formLayout, { name: "type", rules: [
                                        {
                                            required: true,
                                            message: t("management.transactions.fields.required"),
                                        },
                                    ] }, { children: _jsx(Ant.Select, { options: [
                                            {
                                                label: t("management.transactions.create.transaction_type.income"),
                                                value: TransactionType.income,
                                            },
                                            {
                                                label: t("management.transactions.create.transaction_type.expense"),
                                                value: TransactionType.expense,
                                            },
                                            {
                                                label: t("management.transactions.create.transaction_type.internal"),
                                                value: TransactionType.internal,
                                            },
                                        ], style: { width: "100%" }, onChange: (type) => {
                                            setTransactionType(type);
                                            formRef.setFieldValue("type", type);
                                        } }, void 0) }), void 0), transactionType !== TransactionType.internal && (_jsx(Ant.Form.Item, Object.assign({}, formLayout, { name: "externalId", label: t("management.transactions.fields.external"), rules: transactionType !== "all"
                                        ? [
                                            {
                                                required: true,
                                                message: t("management.transactions.fields.required"),
                                            },
                                        ]
                                        : [] }, { children: externalsLoading ? (_jsx(Ant.Spin, {}, void 0)) : (_jsx(Ant.Select, { options: externals.map((e) => ({
                                            label: e.name,
                                            value: e._id,
                                        })) }, void 0)) }), void 0)), _jsx(Ant.Form.Item, Object.assign({}, formLayout, { name: "companyId", label: t("management.transactions.fields.company"), rules: [
                                        {
                                            required: true,
                                            message: t("management.transactions.fields.required"),
                                        },
                                    ] }, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: CompaniesCollection, field: "name", required: true }, void 0) }), void 0), companyId &&
                                    (transactionType === TransactionType.expense ||
                                        transactionType === TransactionType.internal) && (_jsx(Ant.Form.Item, Object.assign({}, formLayout, { name: "sourceBankAccountId", label: t("management.transactions.fields.sourceBankAccount"), rules: [
                                        {
                                            required: true,
                                            message: t("management.transactions.fields.required"),
                                        },
                                    ] }, { children: bankAccountsLoading ? (_jsx(Ant.Spin, {}, void 0)) : (_jsx(Ant.Select, { options: bankAccounts.map((e) => ({
                                            label: `${e.bank.name} - ${e.currency} - ${e.accountNumber.slice(e.accountNumber.length - 6, e.accountNumber.length)}`,
                                            value: e._id,
                                        })) }, void 0)) }), void 0)), companyId &&
                                    (transactionType === TransactionType.income ||
                                        transactionType === TransactionType.internal) && (_jsx(Ant.Form.Item, Object.assign({}, formLayout, { label: t("management.transactions.fields.destinationBankAccount"), name: "destinationBankAccountId", rules: [
                                        {
                                            required: true,
                                            message: t("management.transactions.fields.required"),
                                        },
                                    ] }, { children: bankAccountsLoading ? (_jsx(Ant.Spin, {}, void 0)) : (_jsx(Ant.Select, { options: bankAccounts.map((e) => ({
                                            label: `${e.bank.name} - ${e.currency} - ${e.accountNumber.slice(e.accountNumber.length - 6, e.accountNumber.length)}`,
                                            value: e._id,
                                        })) }, void 0)) }), void 0)), _jsx(Ant.Form.Item, Object.assign({}, formLayout, { name: "transactionIdentifier", label: t("management.transactions.fields.transactionIdentifier") }, { children: _jsx(Ant.Input, {}, void 0) }), void 0), _jsx(Ant.Form.Item, Object.assign({}, formLayout, { name: "amount", label: t("management.transactions.fields.amount"), rules: [
                                        {
                                            required: true,
                                            message: t("management.transactions.fields.required"),
                                        },
                                    ] }, { children: _jsx(Ant.InputNumber, { width: "100%", min: 1 }, void 0) }), void 0), _jsx(Ant.Form.Item, Object.assign({}, formLayout, { name: "notes", label: t("management.transactions.fields.notes") }, { children: _jsx(Ant.Input.TextArea, { rows: 10, style: { minHeight: "200px", maxHeight: "400px" } }, void 0) }), void 0), _jsx(Ant.Form.Item, Object.assign({}, formLayout, { name: "transactionDate", label: t("management.transactions.fields.transactionDate"), rules: [
                                        {
                                            required: true,
                                            message: t("management.transactions.fields.required"),
                                        },
                                    ], initialValue: moment() }, { children: _jsx(Ant.DatePicker, { defaultValue: moment() }, void 0) }), void 0), _jsx(Ant.Form.Item, Object.assign({}, formLayout, { name: "dueDate", label: t("management.transactions.fields.dueDate"), rules: [
                                        {
                                            required: true,
                                            message: t("management.transactions.fields.required"),
                                        },
                                    ] }, { children: _jsx(Ant.DatePicker, {}, void 0) }), void 0), _jsx(Ant.Form.Item, Object.assign({}, formLayout, { name: "transactionFilesIds", label: t("management.transactions.fields.transactionFiles") }, { children: _jsx(FileUpload, { onChange: (ids) => formRef.setFieldValue("transactionFilesIds", ids) }, void 0) }), void 0), _jsxs(Ant.Row, Object.assign({ justify: "end", gutter: 10 }, { children: [_jsx(Ant.Col, Object.assign({ xs: { span: 12, offset: 0 }, sm: { span: 4 } }, { children: _jsx(Ant.Button, Object.assign({ className: "page-transactions-create-widget-btn", type: "ghost", onClick: () => setStatus(false), htmlType: "button" }, { children: t("generics.cancel") }), void 0) }), void 0), _jsx(Ant.Col, Object.assign({ xs: { span: 12 } }, { children: _jsx(Ant.Form.Item, { children: _jsx(Ant.Button, Object.assign({ className: "page-transactions-create-widget-btn", type: "primary", htmlType: "submit" }, { children: t("generics.submit") }), void 0) }, void 0) }), void 0)] }), void 0)] }), void 0)] }), void 0) }), void 0)] }, void 0));
};
